import { extendTheme, ThemeConfig, useColorModeValue } from "@chakra-ui/react";
import "@fontsource/inter";
import "@fontsource/inter/900.css";
import "@fontsource/inter/800.css";
import "@fontsource/inter/700.css";
import "@fontsource/pitagon-sans-mono";

const colors = {
  darkblue: "#416394",
  darkgrey: "#4F4F4F",
  mediumgrey: "#6F6F6F",
  lightgrey: "#BFBFBF",
  lightblue: "#629EF2",
  offwhite: "#FCFAF6",
  offwhiteOpacity: "rgba(252, 250, 246 ,0.3)",
  darkestgrey: "#2B2B2B",
};

const fonts = {
  heading: `"Inter", sans-serif`,
  body: `"Inter", sans-serif`,
  subtitle: `"Pitagon Sans Mono", sans-serif;`,
};

const components = {
  Button: {
    variants: {
      solid: () => ({
        fontSize: ".7rem",
        textTransform: "uppercase",
        fontWeight: "700",
        borderRadius: "1rem",
        letterSpacing: ".02rem",
        color: "#545454",
        transition: "all .4s",
        height: "1.8rem",
      }),
      outline: () => ({
        fontSize: ".7rem",
        textTransform: "uppercase",
        fontWeight: "700",
        borderRadius: "1rem",
        letterSpacing: ".02rem",
        border: "#545454 solid 1px",
        transition: "all .4s",
        background: "transparent",
        height: "1.8rem",
        _hover: {
          background: "transparent",
          border: "black solid 1px",
        },
      }),
      outlineSmall: () => ({
        fontSize: ".5rem",
        textTransform: "uppercase",
        fontWeight: "700",
        borderRadius: "1rem",
        letterSpacing: ".02rem",
        border: "#545454 solid 1px",
        transition: "all .4s",
        background: "transparent",
        height: "1.5rem",
        _hover: {
          background: "transparent",
          border: "black solid 1px",
        },
      }),
    },
  },

  Divider: {
    variants: {
      thick: () => ({
        borderWidth: ".6rem", // change the width of the border
        borderStyle: "solid", // change the style of the border
        borderRadius: 10,
      }),
    },
  },

  Link: {
    variants: {
      navLink: () => ({
        fontFamily: fonts.heading,
        fontSize: ".6rem",
        letterSpacing: ".02rem",
        paddingX: "1rem",
        textDecoration: "none",
        transition: "all 0.4s",
        color: "black",
        _hover: {
          color: "lightblue",
          textDecoration: "none",
          transition: "all 0.4s",
        },
      }),
    },
  },
  Text: {
    variants: {
      type: () => ({
        fontFamily: fonts.subtitle,
        fontSize: ".7rem",
        color: "black",
      }),
      typeBold: () => ({
        fontFamily: fonts.subtitle,
        fontSize: "1rem",
        fontWeight: "200",
        color: "black",
      }),
      typeItalic: () => ({
        fontFamily: fonts.subtitle,
        fontSize: ".7rem",
        color: "black",
        fontStyle: "italic",
      }),
      // HEADER
      bigHeader: () => ({
        fontFamily: fonts.heading,
        letterSpacing: "-.2rem",
        fontWeight: "800",
        fontSize: "3.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#334F2F",
        lineHeight: "100%",
        textAlign: "center",
      }),
      subHeader: () => ({
        fontFamily: fonts.heading,
        fontWeight: "700",
        fontSize: "3rem",
        letterSpacing: "-.2rem",
        color: "#5D6E70",
        textAlign: "center",
      }),
      subHeader2: () => ({
        fontFamily: fonts.heading,
        fontWeight: "700",
        fontSize: "2rem",
        letterSpacing: "-.05rem",
        color: "#5D6E70",
        textAlign: "left",
      }),
      tinyHeader: () => ({
        fontFamily: fonts.heading,
        fontWeight: "bold",
        fontSize: "1.5rem",
        color: "black",
      }),
      tiniestHeader: () => ({
        fontFamily: fonts.heading,
        fontWeight: "bold",
        fontSize: ".9rem",
        color: "black",
        textAlign: "center",
      }),
    },
  },
};

const customTheme = {
  //config,
  colors,
  //styles,
  fonts,
  components,
};

export default extendTheme(customTheme);
